body.sliding-pane__body-open {
  overflow: hidden !important;
}

.sliding-pane {
  display: flex;
  flex-direction: column;
  background: #fff;
  min-width: 100px;
  height: 100%;
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.5);
  transition: transform 0.5s;
  transition-timing-function: ease-out;
  will-change: transform;
  padding: 0 !important;
  max-height: calc(100vh - 50px);
}

.sliding-pane:focus {
  outline-style: none;
}

.sliding-pane_from_right {
  margin-left: auto;
  transform: translateX(100%);
}

.sliding-pane_from_right.ReactModal__Content--after-open {
  transform: translateX(0%);
}

.sliding-pane_from_right.ReactModal__Content--before-close {
  transform: translateX(100%);
}

.sliding-pane_from_left {
  margin-right: auto;
  transform: translateX(-100%);
}

.sliding-pane_from_left.ReactModal__Content--after-open {
  transform: translateX(0%);
}

.sliding-pane_from_left.ReactModal__Content--before-close {
  transform: translateX(-100%);
}

.sliding-pane_from_bottom {
  height: 90vh;
  margin-top: 10vh;
  transform: translateY(100%);
}

.sliding-pane_from_bottom.ReactModal__Content--after-open {
  transform: translateY(0%);
}

.sliding-pane_from_bottom.ReactModal__Content--before-close {
  transform: translateY(100%);
}

.sliding-pane__overlay {
  position: fixed;
  top: 50px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0);
  z-index: 900 !important;
  transition: background-color 0.5s;
  will-change: background-color;
}

.sliding-pane__overlay.ReactModal__Overlay--after-open {
  background-color: rgba(0, 0, 0, 0.3);
}

.sliding-pane__overlay.ReactModal__Overlay--before-close {
  background-color: rgba(0, 0, 0, 0);
}
